<template>
  <div>
    <table
      id="allegatiTable"
      class="mt-3 mb-1 table table-striped table-bordered table-sm"
      style="width:100%;font-size:.9rem;"
    >
      <thead>
        <tr>
          <th class="align-middle text-center">#</th>
          <th class="align-middle text-center">Descrizione</th>
          <th class="align-middle text-center">Genera documento</th>
          <th class="align-middle text-center">Allegato</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(r,idx) in rows"
          :key="idx"
        >
          <td class="align-middle text-nowrap">{{ r.idAllegato }}</td>
          <td class="text-left">{{ r.descrizione }}</td>
          <td class="align-middle text-nowrap">
            <a
              v-if="!isModificato && (!r.standard || r.standard !== 'true')"
              target="_blank"
              @click="urlGeneraDocumento(r)"
              v-b-tooltip.hover
              title="Scarica il documento"
            >
              <font-awesome-icon
                v-if="r.templateId && !!isOpen"
                icon="file-alt"
                size="lg"
                class="text-success cursor-pointer"
              />
            </a>

            <a
              v-else-if="!isModificato && r.standard"
              target="_blank"
              @click="apriForm(r)"
              v-b-tooltip.hover
              title="Gestione allegato standard"
            >
              <font-awesome-icon
                v-if="r.templateId && !!isOpen"
                icon="user-circle"
                size="lg"
                class="text-success cursor-pointer"
              />
            </a>
            <a
              v-else
              @click="warningSaving"
            >
              <font-awesome-icon
                v-if="r.templateId && !!isOpen"
                icon="file-alt"
                size="lg"
                class="text-success cursor-pointer"
              />
            </a>
          </td>
          <td class="text-left px-3">
            <!--b-form-file :id="`${r.idAllegato}`" :ref="`${r.idAllegato}`" v-model="r.fileSelected" class="mt-1" plain /-->
            <input
              :id="`${r.idAllegato}`"
              :ref="`${r.idAllegato}`"
              type="file"
              :value="r.fileSelected"
              accept="image/jpeg,image/png,application/pdf"
              class="mt-1"
              plain
              style="display: none;"
              @change="setFile"
            />
            <!--b-button @click="clearFiles(r)" >Plisci</b-button-->
            <!--a @click="clearFiles(r)" target="_blank" type='file' v-b-tooltip.hover title="Pulisci"-->
            <a
              @click="clearFiles(r)"
              target="_blank"
              type='file'
              v-b-tooltip.hover
              title="Pulisci"
            >
              <font-awesome-icon
                v-if="r.fileName && item.stato !== 'V'"
                icon="trash-alt"
                size="lg"
                class="text-danger "
              />
            </a>
            <a
              @click="selectFile(r)"
              target="_blank"
              type='file'
              v-b-tooltip.hover
              title="Seleziona file"
            >
              <font-awesome-icon
                v-if="!r.fileName && item.stato !== 'V'"
                icon="upload"
                size="lg"
                class="text-success cursor-pointer"
              />
            </a>
            <div :class="(item.stato === 'V') ? 'float-left' : 'float-right'">
              <span class="pt-1">{{r.fileName}}</span>
            </div>
            <!--b class="text-primary"> {{r.fileName}} </b-->

          </td>
        </tr>
        <tr v-if="!rows || !rows.length">
          <td
            :colspan="!isOpen ? '11' : '12'"
            class="text-center font-italic"
          >Nessun allegato</td>
        </tr>
      </tbody>
    </table>
    <!-- <allegato-modal ref="modal" /> -->

    <allegati-standard-modal ref="allegatiStandardModal" />

  </div>
</template>

<script>
import numeral from 'numeral'
import moment from 'moment'
import AllegatiStandardModal from '@/components/AllegatiStandardModal'
// import AllegatoModal from '@/components/AllegatoModal'

export default {
  name: 'AllegatiTable',

  data () {
    return {
    }
  },
  components: {
    // AllegatoModal,
    AllegatiStandardModal
  },
  props: {
    item: { type: Object, required: true },
    fileAllegati: { type: Object },
    isModificato: { type: Boolean }
  },

  computed: {
    numeral () {
      return numeral
    },
    moment () {
      return moment
    },
    isOpen () {
      return this.item.stato === 'B' || this.item.stato === 'P'
    },
    rows () {
      // this.fileAllegati = this.item.allegati
      return this.item.allegati
    }
  },

  methods: {
    clearFiles (refValue) {
      refValue.fileSelected = ''
      refValue.fileName = ''
      // refValue.id = ''
      refValue.uploaded = 'D'

      // console.log('Allegati', this.item.allegati)
    },
    warningSaving () {
      // console.log('isModificato', this.isModificato)
      this.$ui.notify({
        type: 'warning',
        title: 'Attenzione',
        message: 'Bisogna prima confermare le modifiche cliccando su "Salva in bozza"'
      })
    },

    async urlGeneraDocumento (rowData) {
      // Passare i parametri necessari per individuare il documento da generare ed i dati per la compilazione.
      let documentData = this.item.nuoviFamiliari.find(item => item.codiceFiscale === rowData.codiceFiscale) || this.item

      // console.log('Generazione e download documento', rowData.templateId, documentData)

      await this.$store.dispatch('istanze/allegati', { templateId: rowData.templateId, documentData: documentData })
      // return `/api/istanze/${this.item.id}/${rowData.id}/download`
    },
    // ----
    apriForm (rowData) {
      this.$refs.allegatiStandardModal.open({ istanza: this.item, rowData: rowData })
    },
    // async urlAllegatoStandard (rowData) {
    //   // Far vedere eventuali allegati standard preesistenti. Se non presenti è possibile crearne uno.

    //   let documentData = this.item.nuoviFamiliari.find(item => item.codiceFiscale === rowData.codiceFiscale) || this.item

    //   console.log('Gestione allegato standard', rowData.templateId, documentData)

    //   await this.$store.dispatch('istanze/allegati', { templateId: rowData.templateId, documentData: documentData })
    //   // return `/api/istanze/${this.item.id}/${rowData.id}/download`
    // },
    selectFile (refValue) {
      // console.log('selectFile', refValue, this.$refs[refValue.idAllegato][0])

      this.$refs[refValue.idAllegato][0].click()
      // console.log('refValue.fileSelected', refValue.fileSelected)
    },
    setFile (upl) {
      const file = upl.target.files.length ? upl.target.files[0] : ''
      // console.log('setFile', upl.target.id, this.fileAllegati, file)
      this.$emit(upl.target.id, upl.target.files.length ? upl.target.files[0] : '')
      Object.assign(this.fileAllegati, { [upl.target.id]: file })

      let idx = this.item.allegati.findIndex(x => x.idAllegato === upl.target.id)
      // console.log('ARray', this.item.allegati.length, idx, file.name)
      if (idx >= 0) {
        this.item.allegati[idx].fileName = file.name
        if (this.item.allegati[idx].uploaded === '') {
          this.item.allegati[idx].uploaded = 'N'
        } else if (this.fileAllegati[upl.target.id]) {
          this.item.allegati[idx].uploaded = 'U'
        }
      }

      // console.log('this.fileAllegati', this.fileAllegati)
      // console.log('this.item.allegati', JSON.stringify(this.item.allegati))
    }
  }
}
</script>
